// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"415":"components-modal","914":"components-media-slider"}[chunkId] || chunkId) + ".css";
};